(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['history/client/templates/table'] = function(context) {
    return (function() {
      var $c, $e, $o, column, i, j, len, len1, ref, ref1, run;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<colgroup>");
      ref = this.columns.names;
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        $o.push("  <col class='" + ($e($c(column))) + "'>");
      }
      $o.push("</colgroup>\n<thead>");
      if (this.options.show_headings && this.columns.enabled) {
        $o.push("  " + $c(window.HAML["races/client/templates/_headings"]($.extend(this.columns.enabled, {
          options: this.options
        }))));
      }
      $o.push("</thead>\n<tbody>");
      ref1 = this.runs;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        run = ref1[j];
        run.run = run;
        $o.push("  " + $c(window.HAML["races/client/templates/_run"]($.extend(run, {
          columns: this.columns,
          entry: this.entry,
          options: this.options
        }))));
      }
      $o.push("</tbody>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['leaderboards/client/templates/_row'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr class='" + (this.username && this.username === this.settings.own_username ? 'self' : '') + " " + (this.when || '') + "'>\n  <td class='center'>\n    <span class='" + (['result', "" + ($e($c(this.rank <= 3 ? "placed placed-" + this.rank : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
      $o.push("      " + $e($c(this.rank ? $.getOrdinal(this.rank) : '—')));
      if (this.is_dead_heat) {
        $o.push("      <span class='dead-heat'>DH</span>");
      }
      $o.push("    </span>\n  </td>\n  <td>\n    <a href='" + ($e($c(this.url))) + "'>");
      $o.push("      " + $e($c(this.name)));
      $o.push("    </a>\n  </td>\n  <td class='" + (['right', "" + ($e($c($.profitAndLossClass(this.p_and_l))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-popover-href='" + ($e($c((this.settings.tip_url_period || "").replace("00", this.id)))) + "'>");
      $o.push("    " + $c($.toGBP(this.p_and_l) || '—'));
      if (this.settings.tip_url_period && $.toGBP(this.p_and_l)) {
        $o.push("    <i class='glyphicon glyphicon-queen'></i>");
      }
      $o.push("  </td>");
      if (this.settings.covers_today) {
        $o.push("  <td class='" + (['right', "" + ($e($c($.profitAndLossClass(this.p_and_l_today))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-popover-href='" + ($e($c((this.settings.tip_url_today || "").replace("00", this.id)))) + "'>");
        if (this.p_and_l_today != null) {
          $o.push("    " + $c($.toGBP(this.p_and_l_today)));
          if (this.settings.tip_url_today) {
            $o.push("    <i class='glyphicon glyphicon-queen'></i>");
          }
        } else {
          $o.push("    " + $e($c('—')));
        }
        $o.push("  </td>");
      }
      $o.push("  <td class='right'>" + ($e($c(this.num_entries || '—'))) + "</td>");
      if (this.settings.show_admin) {
        $o.push("  <td>");
        $o.push("    " + $e($c(this.access)));
        $o.push("  </td>\n  <td>");
        if (this.twitter) {
          $o.push("    <a href='https://twitter.com/" + ($e($c(this.twitter))) + "'>\n      @" + this.twitter + "\n    </a>");
        }
        $o.push("  </td>");
      }
      $o.push("</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['leaderboards/client/templates/body'] = function(context) {
    return (function() {
      var $c, $e, $o, i, len, ref, row;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.rows && this.rows.length > 0) {
        ref = this.rows;
        for (i = 0, len = ref.length; i < len; i++) {
          row = ref[i];
          $o.push("" + $c(window.HAML["leaderboards/client/templates/_row"]($.extend(row, {
            settings: this.settings
          }))));
        }
      } else {
        $o.push("<tr>\n  <td colspan='" + ($e($c(7))) + "'>No entries in this period.</td>\n</tr>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['profiles/client/templates/_nag_me_row'] = function(context) {
    return (function() {
      var $c, $e, $o, $p, i, label, len, ref, value, value_and_label;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $p = function(text) {
        return text.replace(/\n/g, '&#x000A;');
      };
      $o = [];
      $o.push("<tr data-nag-me-id='" + ($e($c(this.id))) + "'>\n  <td class='horse-name'>\n    <a href='" + ($e($c(this.horse.url))) + "'>" + ($e($c(this.horse.name))) + "</a>\n  </td>\n  <td class='created-at'>" + ($e($c(this.created_at))) + "</td>\n  <td class='nagged-date'>");
      if (this.race) {
        $o.push("    <a href='" + ($e($c(this.race.url))) + "' target='_blank'>" + ($e($c(this.race.time))) + "</a>");
        $o.push("    " + $e($c(' @ ')));
        $o.push("    <a href='" + ($e($c(this.race.racecard_url))) + "' target='_blank'>" + ($e($c(this.race.course.name))) + "</a>\n    <br>\n    <a href='" + ($e($c(this.race.day_url))) + "' target='_blank'>" + ($e($c(this.race.date))) + "</a>");
        $o.push("    " + $e($c(' ')));
        $o.push("    <span style='cursor: pointer' data-title='" + ($e($c(this.title))) + "'>\n      <i class='glyphicons glyphicons question-sign'></i>\n    </span>");
      }
      $o.push("  </td>\n  <td class='right'>" + ($e($c(this.number_of_runs_since_nagged))) + "</td>\n  <td class='nag-me-cell'>\n    <textarea class='note'>" + ($p($e($c(this.note)))) + "</textarea>\n    <div class='pull-left text-muted'>\n      Number of characters left:\n      <span class='symbol-count'>" + ($e($c(this.note_max_length - this.note.length))) + "</span>\n    </div>\n  </td>\n  <td>\n    <select class='auto-delete form-control'>");
      ref = this.auto_delete_choices;
      for (i = 0, len = ref.length; i < len; i++) {
        value_and_label = ref[i];
        value = value_and_label[0];
        label = value_and_label[1];
        $o.push("      <option value='" + ($e($c(value))) + "' selected='" + ($e($c(this.auto_delete === value))) + "'>" + ($e($c(label))) + "</option>");
      }
      $o.push("    </select>\n  </td>\n  <td>\n    <button class='btn btn-default save' data-title='Save this NagMe' disabled='disabled'>\n      <i class='glyphicon glyphicon-floppy-saved'></i>\n    </button>\n    <button class='btn btn-default delete' data-title='Delete this NagMe'>\n      <i class='glyphicon glyphicon-remove-circle'></i>\n    </button>\n  </td>\n</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['profiles/client/templates/mobile_preset_dialog'] = function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='modal-header'>\n  <div class='h1 modal-title'>Select race columns preset</div>\n</div>\n<div class='modal-body'>\n  <div class='controls row'>\n    <div class='col-sm-3 hidden-xs'>\n      <h4>Presets</h4>\n    </div>\n    <div class='col-sm-3 col-xs-4'>\n      <button class='btn btn-warning preset' type='button' data-dismiss='modal' data-title='Select Basic preset' data-preset='BASIC'>\n        Basic\n      </button>\n    </div>\n    <div class='col-sm-3 col-xs-3'>\n      <button class='btn btn-warning preset' type='button' data-dismiss='modal' data-title='Select Professional preset' data-preset='PROFESSIONAL'>\n        <span class='hidden-xs'>Professional</span>\n        <span class='hidden-lg hidden-md hidden-sm'>Pro</span>\n      </button>\n    </div>\n    <div class='col-sm-3 col-xs-5'>\n      <button class='btn btn-warning preset' type='button' data-dismiss='modal' data-title='Select Statistician preset' data-preset='STATISTICIAN'>\n        Statistician\n      </button>\n    </div>\n  </div>\n  <div class='row'>\n    <div class='col-xs-10 col-xs-offset-1'>\n      <p>\n        If you would like to change your style in the future, you can click on settings\n        <i class='glyphicon glyphicon-cog large' aria-hidden='true'></i>\n        and click on \"Style Settings\" where you can change the style to suit your needs.\n      </p>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['profiles/client/templates/nag_me_dialog'] = function(context) {
    return (function() {
      var $c, $e, $o, $p, i, label, len, ref, value, value_and_label;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $p = function(text) {
        return text.replace(/\n/g, '&#x000A;');
      };
      $o = [];
      $o.push("<div class='modal-header'>\n  <button class='close' type='button' data-dismiss='modal' aria-label='Close' data-placement='bottom' data-title='Close the dialog'>\n    <span aria-hidden='true'>&times;</span>\n  </button>\n  <div class='h1 modal-title'>\n    <span>" + ($e($c(this.title))) + "</span>\n  </div>\n</div>\n<div class='modal-body'>\n  <form>\n    <input id='nag-me-id' type='hidden' name='id' value='" + ($e($c(this.id))) + "'>\n    <input id='nag-me-run-id' type='hidden' name='run-id' value='" + ($e($c(this.run_id))) + "'>\n    <input id='nag-me-horse-id' type='hidden' name='horse-id' value='" + ($e($c(this.horse_id))) + "'>");
      if (this.mode === "search") {
        $o.push("    <label>Choose a horse:</label>\n    <div>\n      <div class='pull-right text-danger' id='nag-me-error'></div>\n      <input class='form-control' id='nag-me-horse-typeahead' style='margin-left:5px' data-search-url='" + ($e($c(this.typeahead_horse_name_url))) + "' type='text' placeholder='Type name of a horse'>\n    </div>");
      }
      $o.push("    <div>\n      <label>Note:</label>\n      <textarea class='note' id='nag-me-note' data-max-length='" + ($e($c(this.note_max_length))) + "' style='width:100%; display:block' name='note'>" + ($p($e($c(this.note)))) + "</textarea>\n      <span class='pull-left text-muted'>\n        Number of characters left:\n        <span class='symbol-count'>" + ($e($c(this.note_max_length - this.note.length))) + "</span>\n      </span>\n      <div class='pull-right' style='margin-top: 5px'>\n        Number of races to auto-delete after:\n        <select class='form-control' id='nag-me-auto-delete' style='display: inline; width: auto'>");
      ref = this.auto_delete_choices;
      for (i = 0, len = ref.length; i < len; i++) {
        value_and_label = ref[i];
        value = value_and_label[0];
        label = value_and_label[1];
        $o.push("          <option value='" + ($e($c(value))) + "' selected='" + ($e($c(this.auto_delete === value))) + "'>" + ($e($c(label))) + "</option>");
      }
      $o.push("        </select>\n        <span style='cursor: pointer; margin-left:5px' data-title='Remove the horse from NagMe list after a selected number of successful runs'>\n          <i class='glyphicon glyphicon-question-sign'></i>\n        </span>\n      </div>\n      <div class='clearfix'></div>\n    </div>\n  </form>\n</div>\n<div class='modal-footer'>\n  <button class='btn btn-primary save-nag-me' type='button' data-title='Add to NagMe list (note can be empty)'>");
      $o.push("    " + $e($c(this.mode === "edit" ? "Save" : "Create")));
      $o.push("  </button>");
      if (this.mode === "edit") {
        $o.push("  <button class='btn btn-default remove-nag-me' type='button' data-title='Remove from NagMe list'>Remove</button>");
      }
      $o.push("  <button class='btn btn-default cancel' type='button' data-dismiss='modal'>Cancel</button>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_combination_stats'] = function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.columns.enabled.jockey_and_trainer_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.combination_stats.jockey_and_trainer_a, {
          value: null,
          options: this.options,
          name: 'The same jockey & trainer stats'
        }))));
      }
      if (this.columns.enabled.jockey_and_sire_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.combination_stats.jockey_and_sire_a, {
          value: null,
          options: this.options,
          name: 'The same jockey & sire stats'
        }))));
      }
      if (this.columns.enabled.trainer_and_sire_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.combination_stats.trainer_and_sire_a, {
          value: null,
          options: this.options,
          name: 'The same trainer & sire stats'
        }))));
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_headings'] = function(context) {
    return (function() {
      var $c, $e, $o, stats_mode_str;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr class='" + (['headings', "" + ($e($c(this.is_abandoned ? "abandoned" : this.options.stats_mode)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
      if (this.date) {
        $o.push("  <th data-title='Date of the race'>Date</th>");
      }
      if (this.time) {
        $o.push("  <th data-title='Start time of the race'>Time</th>");
      }
      if (this.course) {
        $o.push("  <th data-title='Course the race was run on'>Course</th>");
      }
      if (this.distance) {
        $o.push("  <th data-title='Distance run'>Distance</th>");
      }
      if (this.going) {
        $o.push("  <th data-title='Going on course at time of race'>Going</th>");
      }
      if (this.nap) {
        $o.push("  <th data-title='NAP competition entry'>NAP</th>");
      }
      if (this.cloth_number) {
        $o.push("  <th data-title='Number and colours'>#</th>");
      }
      if (this.stall_draw) {
        $o.push("  <th data-title='Stall draw number (colouring based on the strike rate of horses starting in the stall)'>Draw</th>");
      }
      if (this.horse_name) {
        $o.push("  <th class='" + (['js_horse_name', "" + ($e($c(this.options.freeze_horse_name ? 'frozen' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-title='Name of horse'>Horse Name</th>");
      }
      if (this.nag_me) {
        $o.push("  <th data-title='Note about a horse'>NagMe</th>");
      }
      if (this.result) {
        $o.push("  <th data-title='Position at finish'>Pos</th>");
      }
      if (this.rtr_score) {
        $o.push("  <th data-title='Score assigned to the horse by the RatingTheRaces algorithm'>RTR Score</th>");
      }
      if (this.rtr_rank || !this.options.extended_info) {
        $o.push("  <th data-title='Rank of horses, based on Value Odds'>RTR Rank</th>");
      }
      if (this.value_odds) {
        $o.push("  <th data-title='Odds calculated by RatingTheRaces'>Value Odds</th>");
      }
      if (this.win_price) {
        $o.push("  <th data-title='Exchange Starting Price to win (If no XSP available, latest Exchange Price is shown in parenthesis)'>Win Odds</th>");
      }
      if (this.win_price_reduction) {
        $o.push("  <th data-title='Win price reduction'>Win PR</th>");
      }
      if (this.value_percentage) {
        $o.push("  <th data-title='Value Odds divided by Actual Odds (>100% is good)'>Value %</th>");
      }
      if (this.industry_starting_price) {
        $o.push("  <th data-title='Industry Start Price (Hover for other display of odds)'>ISP</th>");
      }
      if (this.place_price) {
        $o.push("  <th data-title='Excahnge Starting Price to place (If no XSP available, latest betfair price is shown in parenthesis)'>Place Odds</th>");
      }
      if (this.place_price_reduction) {
        $o.push("  <th data-title='Place price reduction'>Place PR</th>");
      }
      if (this.form) {
        $o.push("  <th data-title='Form over last few races'>Form</th>");
      }
      if (this.r) {
        $o.push("  <th>R</th>");
      }
      if (this.r10) {
        $o.push("  <th>R10</th>");
      }
      if (this.r9) {
        $o.push("  <th>R9</th>");
      }
      if (this.r8) {
        $o.push("  <th>R8</th>");
      }
      if (this.r7) {
        $o.push("  <th>R7</th>");
      }
      if (this.r6) {
        $o.push("  <th>R6</th>");
      }
      if (this.r5) {
        $o.push("  <th>R5</th>");
      }
      if (this.r4) {
        $o.push("  <th>R4</th>");
      }
      if (this.r3) {
        $o.push("  <th>R3</th>");
      }
      if (this.r2) {
        $o.push("  <th>R2</th>");
      }
      if (this.r1) {
        $o.push("  <th>R1</th>");
      }
      if (this.av10) {
        $o.push("  <th class='no-padding' data-title='Average of R1-10 values'>\n    <div class='average'>AV10</div>\n  </th>");
      }
      if (this.av10_rank) {
        $o.push("  <th data-title='Rank based on AV10 value'>AV10 Rank</th>");
      }
      if (this.av3) {
        $o.push("  <th class='no-padding' data-title='Average of R1-3 values'>\n    <div class='average'>AV3</div>\n  </th>");
      }
      if (this.av3_rank) {
        $o.push("  <th data-title='Rank based on AV3 value'>AV3 Rank</th>");
      }
      if (this["class"]) {
        $o.push("  <th data-title='Change in class'>Class</th>");
      }
      if (this.won_on_course) {
        $o.push("  <th data-title='Won on this course?'>C</th>");
      }
      if (this.won_at_distance) {
        $o.push("  <th data-title='Won at this distance?'>D</th>");
      }
      if (this.sex) {
        $o.push("  <th data-title='Sex of Horse'>Sex</th>");
      }
      if (this.age) {
        $o.push("  <th data-title='Age of Horse, in years'>Age</th>");
      }
      if (this.days) {
        $o.push("  <th data-title='Days since last race'>Days</th>");
      }
      stats_mode_str = this.options.stats_mode === "win_pr" ? "PR" : "SR";
      if (this.horse_a_stats) {
        $o.push("  <th data-title='Stats for the Horse'>H " + stats_mode_str + "</th>");
      }
      if (this.horse_c_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Course'>H C " + stats_mode_str + "</th>");
      }
      if (this.horse_t_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Race Type'>H T " + stats_mode_str + "</th>");
      }
      if (this.horse_d_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Distance'>H D " + stats_mode_str + "</th>");
      }
      if (this.horse_dt_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Distance & Race Type'>H DT " + stats_mode_str + "</th>");
      }
      if (this.horse_cd_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Course & Distance'>H CD " + stats_mode_str + "</th>");
      }
      if (this.horse_g_stats) {
        $o.push("  <th data-title='Stats for the Horse on this Going'>H G " + stats_mode_str + "</th>");
      }
      if (this.trainer_name) {
        $o.push("  <th data-title='Name of trainer'>Trainer name</th>");
      }
      if (this.trainer_d7_stats) {
        $o.push("  <th data-title='Stats for the Trainer in the last 7 days'>T 7 " + stats_mode_str + "</th>");
      }
      if (this.trainer_d14_stats) {
        $o.push("  <th data-title='Stats for the Trainer in the last 14 days'>T 14 " + stats_mode_str + "</th>");
      }
      if (this.trainer_d28_stats) {
        $o.push("  <th data-title='Stats for the Trainer in the last 28 days'>T 28 " + stats_mode_str + "</th>");
      }
      if (this.trainer_a_stats) {
        $o.push("  <th data-title='Stats for the Trainer'>T " + stats_mode_str + "</th>");
      }
      if (this.trainer_c_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Course'>T C " + stats_mode_str + "</th>");
      }
      if (this.trainer_t_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Race Type'>T T " + stats_mode_str + "</th>");
      }
      if (this.trainer_d_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Distance'>T D " + stats_mode_str + "</th>");
      }
      if (this.trainer_dt_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Distance & Race Type'>T DT " + stats_mode_str + "</th>");
      }
      if (this.trainer_cd_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Course & Distance'>T CD " + stats_mode_str + "</th>");
      }
      if (this.trainer_g_stats) {
        $o.push("  <th data-title='Stats for the Trainer on this Going'>T G " + stats_mode_str + "</th>");
      }
      if (this.jockey_name) {
        $o.push("  <th data-title='Name of jockey'>Jockey name</th>");
      }
      if (this.jockey_d7_stats) {
        $o.push("  <th data-title='Stats for the Jockey in the last 7 days'>J 7 " + stats_mode_str + "</th>");
      }
      if (this.jockey_d14_stats) {
        $o.push("  <th data-title='Stats for the Jockey in the last 14 days'>J 14 " + stats_mode_str + "</th>");
      }
      if (this.jockey_d28_stats) {
        $o.push("  <th data-title='Stats for the Jockey in the last 28 days'>J 28 " + stats_mode_str + "</th>");
      }
      if (this.jockey_a_stats) {
        $o.push("  <th data-title='Stats for the Jockey'>J " + stats_mode_str + "</th>");
      }
      if (this.jockey_c_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Course'>J C " + stats_mode_str + "</th>");
      }
      if (this.jockey_t_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Race Type'>J T " + stats_mode_str + "</th>");
      }
      if (this.jockey_d_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Distance'>J D " + stats_mode_str + "</th>");
      }
      if (this.jockey_dt_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Distance & Race Type'>J DT " + stats_mode_str + "</th>");
      }
      if (this.jockey_cd_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Course & Distance'>J CD " + stats_mode_str + "</th>");
      }
      if (this.jockey_g_stats) {
        $o.push("  <th data-title='Stats for the Jockey on this Going'>J G " + stats_mode_str + "</th>");
      }
      if (this.sire_name) {
        $o.push("  <th data-title='Name of sire'>Sire name</th>");
      }
      if (this.sire_a_stats) {
        $o.push("  <th data-title='Stats for the Sire'>S " + stats_mode_str + "</th>");
      }
      if (this.sire_c_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Course'>S C " + stats_mode_str + "</th>");
      }
      if (this.sire_t_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Race Type'>S T " + stats_mode_str + "</th>");
      }
      if (this.sire_d_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Distance'>S D " + stats_mode_str + "</th>");
      }
      if (this.sire_dt_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Distance & Race Type'>S DT " + stats_mode_str + "</th>");
      }
      if (this.sire_cd_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Course & Distance'>S CD " + stats_mode_str + "</th>");
      }
      if (this.sire_g_stats) {
        $o.push("  <th data-title='Stats for the Sire on this Going'>S G " + stats_mode_str + "</th>");
      }
      if (this.jockey_and_trainer_a_stats) {
        $o.push("  <th data-title='Stats for the same Jockey & Trainer'>J&T " + stats_mode_str + "</th>");
      }
      if (this.jockey_and_sire_a_stats) {
        $o.push("  <th data-title='Stats for the same Jockey & Sire'>J&S " + stats_mode_str + "</th>");
      }
      if (this.trainer_and_sire_a_stats) {
        $o.push("  <th data-title='Stats for the same Trainer & Sire'>T&S " + stats_mode_str + "</th>");
      }
      if (this.combined_ae) {
        $o.push("  <th data-title='Combined Actual/Expected for ALL horse/trainer/jockey/sire stats to Win and Place'>C A/E</th>");
      }
      if (!this.options.extended_info) {
        $o.push("  <th data-title='Premium members see over 50 additional statistics!'>50+ Premium Insights</th>");
      }
      $o.push("</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_horse_stats'] = function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.columns.enabled.horse_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.a, {
          value: null,
          options: this.options,
          name: 'Horse stats'
        }))));
      }
      if (this.columns.enabled.horse_c_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.c, {
          value: null,
          options: this.options,
          name: 'Horse on this course stats'
        }))));
      }
      if (this.columns.enabled.horse_t_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.t, {
          value: null,
          options: this.options,
          name: 'Horse on this race type stats'
        }))));
      }
      if (this.columns.enabled.horse_d_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.d, {
          value: null,
          options: this.options,
          name: 'Horse on this distance stats'
        }))));
      }
      if (this.columns.enabled.horse_dt_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.dt, {
          value: null,
          options: this.options,
          name: 'Horse on this distance & race type stats'
        }))));
      }
      if (this.columns.enabled.horse_cd_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.cd, {
          value: null,
          options: this.options,
          name: 'Horse on this course & distance stats'
        }))));
      }
      if (this.columns.enabled.horse_g_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.horse.stats.g, {
          value: null,
          options: this.options,
          name: 'Horse on this going stats'
        }))));
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_jockey_stats'] = function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.columns.enabled.jockey_name) {
        $o.push("" + $c(window.HAML["races/client/templates/_name"]($.extend(this.jockey, {
          js_cell_class: "js_jockey_name",
          options: this.options
        }))));
      }
      if (this.columns.enabled.jockey_d7_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.d7, {
          value: null,
          options: this.options,
          name: 'Jockey in the last 7 days stats'
        }))));
      }
      if (this.columns.enabled.jockey_d14_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.d14, {
          value: null,
          options: this.options,
          name: 'Jockey in the last 14 days stats'
        }))));
      }
      if (this.columns.enabled.jockey_d28_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.d28, {
          value: null,
          options: this.options,
          name: 'Jockey in the last 28 days stats'
        }))));
      }
      if (this.columns.enabled.jockey_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.a, {
          value: null,
          options: this.options,
          name: 'Jockey stats'
        }))));
      }
      if (this.columns.enabled.jockey_c_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.c, {
          value: null,
          options: this.options,
          name: 'Jockey on this course stats'
        }))));
      }
      if (this.columns.enabled.jockey_t_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.t, {
          value: null,
          options: this.options,
          name: 'Jockey on this race type stats'
        }))));
      }
      if (this.columns.enabled.jockey_d_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.d, {
          value: null,
          options: this.options,
          name: 'Jockey on this distance stats'
        }))));
      }
      if (this.columns.enabled.jockey_dt_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.dt, {
          value: null,
          options: this.options,
          name: 'Jockey on this distance & race type stats'
        }))));
      }
      if (this.columns.enabled.jockey_cd_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.cd, {
          value: null,
          options: this.options,
          name: 'Jockey on this course & distance stats'
        }))));
      }
      if (this.columns.enabled.jockey_g_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.jockey.stats.g, {
          value: null,
          options: this.options,
          name: 'Jockey on this going stats'
        }))));
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_name'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<td class='" + (['hover', 'name', "" + ($e($c(this.extra_class ? "" + this.extra_class : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' style='" + ($e($c(this.colour ? "background: #" + this.colour + ";" : ""))) + "'>\n  <div class='" + (['updates', "" + ($e($c(this.js_cell_class ? "" + this.js_cell_class : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
      if (this.nap_pick_data && this.nap_pick_data.num_picks) {
        $o.push("    <div class='badge stats' data-title='' data-template-context='" + ($e($c(JSON.stringify(this.nap_pick_data)))) + "' data-template-file='races/client/templates/nap_count_tip'>");
        $o.push("      " + $e($c(this.nap_pick_data.num_picks)));
        $o.push("    </div>");
      }
      $o.push("    <div class='" + (['notranslate', "" + ($e($c(this.is_highlighted ? "bold" : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' translate='no'>\n      <span>\n        <a href='" + ($e($c(this.url))) + "' data-title='View history'>");
      if (this.name === "Unknown") {
        $o.push("          <em>Unknown</em>");
      } else {
        $o.push("          " + $e($c(this.name)));
      }
      $o.push("        </a>\n      </span>");
      if (this.nationality) {
        $o.push("      <span class='" + (['bred', "" + ($e($c(this.options.show_nationalities ? "" : "hidden")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>(" + this.nationality + ")</span>");
      }
      $o.push("    </div>\n  </div>\n</td>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_nap'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.options.updating_table) {
        $o.push("<td class='nap'></td>");
      } else {
        if (this.options.is_history) {
          $o.push("<td class='hover nap'>");
          if (this.entry === "nap") {
            $o.push("  <div data-title='Your NAP pick'>NAP</div>");
          }
          if (this.entry === "nb") {
            $o.push("  <div data-title='Your next best pick'>NB</div>");
          }
          if (this.entry === "reserve") {
            $o.push("  <div data-title='Your reserve pick'>Res</div>");
          }
          $o.push("</td>");
        } else {
          $o.push("<td class='nap no-hover'>");
          if (!this.entry.entry_stage) {
            if (this.entry.can_enter) {
              if (this.race.has_started) {
                $o.push("  <select class='form-control' disabled>\n    <option value=''></option>\n  </select>");
              } else {
                $o.push("  <select class='form-control'>\n    <option value=''></option>");
                if (this.id === this.entry.nap_id) {
                  $o.push("    <option value='nap' selected>NAP</option>");
                } else {
                  $o.push("    <option value='nap'>\n      NAP");
                  $o.push("      " + $e($c(this.entry.nap_label)));
                  $o.push("    </option>");
                }
                if (this.id === this.entry.nb_id) {
                  $o.push("    <option value='nb' selected>NB</option>");
                } else {
                  $o.push("    <option value='nb'>\n      NB");
                  $o.push("      " + $e($c(this.entry.nb_label)));
                  $o.push("    </option>");
                }
                if (this.id === this.entry.reserve_id) {
                  $o.push("    <option value='reserve' selected>Res</option>");
                } else {
                  $o.push("    <option value='reserve'>\n      Res");
                  $o.push("      " + $e($c(this.entry.reserve_label)));
                  $o.push("    </option>");
                }
                $o.push("  </select>");
              }
            } else {
              if (this.entry.is_submitted) {
                if (this.entry.nap_id === this.id) {
                  $o.push("  <div data-title='Your NAP pick'>NAP</div>");
                }
                if (this.entry.nb_id === this.id) {
                  $o.push("  <div data-title='Your next best pick'>NB</div>");
                }
                if (this.entry.reserve_id === this.id) {
                  $o.push("  <div data-title='Your reserve pick'>Res</div>");
                }
              }
            }
          }
          $o.push("</td>");
        }
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_r_value'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.value) {
        $o.push("<td class='" + (['r', "" + ($e($c(this.data.rtr_rank ? "popup_mark" : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n  <div style='" + ($e($c(this.data.colour ? "background: #" + this.data.colour + ";" : ""))) + "'>");
        if (this.value) {
          if (this.data.url) {
            $o.push("    <span data-title='' data-template-context='" + ($e($c(JSON.stringify(this.data)))) + "' data-template-file='races/client/templates/r_data_tip'>");
            $o.push("      " + $e($c($.toFixed(this.value, 1))));
            $o.push("    </span>");
          } else {
            $o.push("    " + $e($c($.toFixed(this.value, 1))));
          }
        } else {
          $o.push("    \-");
        }
        $o.push("  </div>\n</td>");
      } else {
        $o.push("<td class='hover'></td>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_r_values'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.options.is_history) {
        if (this.columns.enabled.r) {
          if (this.r && this.r.value) {
            $o.push("<td>\n  <div style='" + ($e($c(this.r.colour ? "background: #" + this.r.colour + ";" : ""))) + "'>" + ($e($c($.toFixed(this.r.value, 1)))) + "</div>\n</td>");
          } else {
            $o.push("<td class='hover'></td>");
          }
        }
      } else {
        if (this.columns.enabled.r10) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r10, {
            data: this.r10_data
          }))));
        }
        if (this.columns.enabled.r9) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r9, {
            data: this.r9_data
          }))));
        }
        if (this.columns.enabled.r8) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r8, {
            data: this.r8_data
          }))));
        }
        if (this.columns.enabled.r7) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r7, {
            data: this.r7_data
          }))));
        }
        if (this.columns.enabled.r6) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r6, {
            data: this.r6_data
          }))));
        }
        if (this.columns.enabled.r5) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r5, {
            data: this.r5_data
          }))));
        }
        if (this.columns.enabled.r4) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r4, {
            data: this.r4_data
          }))));
        }
        if (this.columns.enabled.r3) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r3, {
            data: this.r3_data
          }))));
        }
        if (this.columns.enabled.r2) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r2, {
            data: this.r2_data
          }))));
        }
        if (this.columns.enabled.r1) {
          $o.push("" + $c(window.HAML["races/client/templates/_r_value"]($.extend(this.r1, {
            data: this.r1_data
          }))));
        }
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_result'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<td class='hover result'>\n  <div class='updates'>");
      if (this.is_runner) {
        if (this.result.value) {
          $o.push("    <span class='" + (['result', "" + ($e($c(this.result.placed ? "placed placed-" + this.result.value : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
          $o.push("      " + $e($c($.getOrdinal(this.result.value))));
          if (this.in_dead_heat) {
            $o.push("      <span class='dead-heat'>DH</span>");
          }
          $o.push("    </span>");
        } else {
          if (this.result.placed) {
            $o.push("    <span class='placed result' data-title='This runner placed'>P</span>");
          } else {
            if (this.result.finish_state_title) {
              $o.push("    <span class='result' data-title='This runner " + ($e($c(this.result.finish_state_title))) + "'>" + ($e($c(this.result.finish_state))) + "</span>");
            }
            if (this.result.probable_non_runner) {
              $o.push("    <span class='result'>\n      <i class='glyphicon glyphicon-question-sign' data-title='This runner is likely a non-runner (it doesn&quot;t have odds, but other horses do)'></i>\n    </span>");
            }
          }
        }
      } else {
        $o.push("    <span class='result' data-title='Non-runner'>NR</span>");
      }
      $o.push("  </div>\n</td>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_run'] = function(context) {
    return (function() {
      var $c, $e, $o, furlongs, value;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr class='" + (this.is_runner ? "runner" : "non-runner") + " " + (this.is_selected ? "active" : "") + " " + (!this.is_runner && !this.options.show_non_runners ? "hidden" : "") + "' data-run-id='" + ($e($c(this.id))) + "' data-time='" + ($e($c(this.race.time))) + "' data-course='" + ($e($c(this.race.course.name))) + "'>");
      if (this.columns.enabled.date) {
        $o.push("  <td class='date hover'>\n    <div>\n      <a href='" + ($e($c(this.race.all_races_url))) + "'>" + ($e($c(this.race.date))) + "</a>\n    </div>\n  </td>");
      }
      if (this.columns.enabled.time) {
        $o.push("  <td class='hover time'>\n    <div>\n      <a href='" + ($e($c(this.race.url))) + "'>" + ($e($c(this.race.time))) + "</a>\n    </div>\n  </td>");
      }
      if (this.columns.enabled.course) {
        $o.push("  <td class='course hover'>\n    <div>\n      <span>" + ($e($c(this.race.course.name))) + "</span>");
        if (this.race.course.track.abbr) {
          $o.push("      <span data-title='" + ($e($c(this.race.course.track.desc))) + "'>(" + this.race.course.track.abbr + ")</span>");
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.distance) {
        $o.push("  <td class='distance hover'>");
        furlongs = this.race.distance.furlongs;
        furlongs = Math.floor(furlongs) !== furlongs ? (Math.floor(furlongs)) + " &half;" : furlongs;
        $o.push("    <div data-title='Approximately " + ($e($c(furlongs))) + " furlongs'>" + ($e($c(this.race.distance.value))) + "</div>\n  </td>");
      }
      if (this.columns.enabled.going) {
        $o.push("  <td class='going hover'>\n    <div>" + ($e($c(this.race.going))) + "</div>\n  </td>");
      }
      if (this.columns.enabled.nap) {
        $o.push("  " + $c(window.HAML["races/client/templates/_nap"](this.run)));
      }
      if (this.columns.enabled.cloth_number) {
        $o.push("  <td class='cloth_number no-hover'>");
        if (this.cloth.image_url) {
          $o.push("    <div class='silks updates' data-title='" + ($e($c(this.cloth.number))) + "<br/>" + ($e($c(this.cloth.description || ''))) + "'>\n      <img class='colours' src='" + ($e($c(this.cloth.image_url))) + "' alt='silks'>\n      <span class='number'>" + ($e($c(this.cloth.number))) + "</span>\n    </div>");
        } else {
          $o.push("    <div class='updates'>" + ($e($c(this.cloth.number))) + "</div>");
        }
        $o.push("  </td>");
      }
      if (this.columns.enabled.stall_draw) {
        if (this.stall_draw.stats != null) {
          $o.push("  " + $c(window.HAML["races/client/templates/_stats"]($.extend(this.stall_draw.stats, {
            value: this.stall_draw.value,
            options: this.options,
            name: 'Draw stats'
          }))));
        } else {
          $o.push("  <td class='hover'>\n    <div class='right updates'>" + ($e($c(this.stall_draw.value))) + "</div>\n  </td>");
        }
      }
      if (this.columns.enabled.horse_name) {
        $o.push("  " + $c(window.HAML["races/client/templates/_name"]($.extend(this.horse, {
          extra_class: "" + (this.options.freeze_horse_name ? 'js_horse_name frozen' : 'js_horse_name'),
          options: this.options,
          entry: this.entry
        }))));
      }
      if (!this.entry.entry_stage) {
        if (this.columns.enabled.nag_me) {
          $o.push("  <td class='hover nag_me'>\n    <div class='updates'>");
          if (this.nag_me) {
            $o.push("      <span class='active nag-me' data-id='" + ($e($c(this.nag_me.id))) + "' data-auto-delete='" + ($e($c(this.nag_me.auto_delete))) + "' data-title='Edit NagMe' data-note='" + ($e($c(this.nag_me.note))) + "' data-horse-id='" + ($e($c(this.horse.id))) + "' data-horse-name='" + ($e($c(this.horse.name))) + "' data-horse-nationality='" + ($e($c(this.horse.nationality))) + "'>NagMe</span>");
          } else {
            $o.push("      <span class='nag-me' data-title='Add NagMe' data-horse-id='" + ($e($c(this.horse.id))) + "' data-horse-name='" + ($e($c(this.horse.name))) + "' data-horse-nationality='" + ($e($c(this.horse.nationality))) + "'>NagMe</span>");
          }
          $o.push("    </div>\n  </td>");
        }
      } else {
        if (this.columns.enabled.nag_me) {
          $o.push("  <td class='disable hover nag_me' style='pointer-events: none;'>\n    <div class='updates'>");
          if (this.nag_me) {
            $o.push("      <span class='active nag-me' data-id='" + ($e($c(this.nag_me.id))) + "' data-auto-delete='" + ($e($c(this.nag_me.auto_delete))) + "' data-title='Edit NagMe' data-note='" + ($e($c(this.nag_me.note))) + "' data-horse-id='" + ($e($c(this.horse.id))) + "' data-horse-name='" + ($e($c(this.horse.name))) + "' data-horse-nationality='" + ($e($c(this.horse.nationality))) + "'>NagMe</span>");
          } else {
            $o.push("      <span class='bg-disable nag-me' style='background: #ccc;' data-title='Add NagMe' data-horse-id='" + ($e($c(this.horse.id))) + "' data-horse-name='" + ($e($c(this.horse.name))) + "' data-horse-nationality='" + ($e($c(this.horse.nationality))) + "'>NagMe</span>");
          }
          $o.push("    </div>\n  </td>");
        }
      }
      if (this.columns.enabled.result) {
        $o.push("  " + $c(window.HAML["races/client/templates/_result"](this.run)));
      }
      if (this.options.extended_info) {
        if (this.columns.enabled.rtr_score) {
          $o.push("  <td class='hover rtr_score'>");
          if (this.rtr_score.value) {
            $o.push("    <div class='updates' style='" + ($e($c(this.rtr_score.colour ? "background: #" + this.rtr_score.colour + ";" : ""))) + "'>");
            $o.push("      " + $e($c($.toFixed(this.rtr_score.value, 2))));
            $o.push("    </div>");
          } else {
            $o.push("    <div class='updates'></div>");
          }
          $o.push("  </td>");
        }
      } else {
        $o.push("  <td class='hover locked_rtr_score' data-title='Only Premium Members get to see this'>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;'></i>\n  </td>");
      }
      if (this.options.extended_info) {
        if (this.columns.enabled.rtr_rank) {
          $o.push("  <td class='hover rtr_rank'>\n    <div class='updates' style='" + ($e($c(this.rtr_rank.colour ? "background: #" + this.rtr_rank.colour + ";" : ""))) + "'>" + ($e($c(this.rtr_rank.value))) + "</div>\n  </td>");
        }
      } else {
        $o.push("  <td class='hover locked_rtr_rank' data-title='Only Premium Members get to see this'>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;'></i>\n  </td>");
      }
      if (this.options.extended_info) {
        if (this.columns.enabled.value_odds) {
          $o.push("  <td class='hover value_odds'>");
          if (this.value_odds.value) {
            $o.push("    <div class='updates' style='" + ($e($c(this.value_odds.colour ? "background: #" + this.value_odds.colour + ";" : ""))) + "'>");
            $o.push("      " + $e($c($.toFixed(this.value_odds.value, 2))));
            $o.push("    </div>");
          } else {
            $o.push("    <div class='updates'></div>");
          }
          $o.push("  </td>");
        }
      } else {
        $o.push("  <td class='hover locked_value_odds' data-title='Only Premium Members get to see this'>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;'></i>\n  </td>");
      }
      if (this.columns.enabled.win_price) {
        $o.push("  <td class='hover win_price'>\n    <div class='updates'>");
        if (this.win_price.value) {
          value = $.toFixed(this.win_price.value, 2);
          $o.push("      " + $e($c(this.win_price.sp ? value : "(" + value + ")")));
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.win_price_reduction) {
        $o.push("  <td class='hover win_price_reduction'>\n    <div class='updates'>");
        if (this.win_price.reduction != null) {
          $o.push("      " + ($.toFixed(this.win_price.reduction, 2)) + "%");
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.value_percentage) {
        $o.push("  <td class='hover value_percentage'>");
        if (this.value_percentage.value) {
          $o.push("    <div class='" + (['updates', "" + ($e($c(this.value_percentage.is_highlighted ? "winner" : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n      " + ($.toFixed(this.value_percentage.value, 2)) + "%\n    </div>");
        } else {
          $o.push("    <div class='updates'></div>");
        }
        $o.push("  </td>");
      }
      if (this.columns.enabled.industry_starting_price) {
        $o.push("  <td class='hover industry_starting_price'>\n    <div class='updates'>");
        if (this.isp_decimal && this.isp_fractional) {
          $o.push("      <div class='" + (['isp-decimal', "" + ($e($c(this.options.show_fractional_odds ? "hidden" : "")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-title='" + ($e($c(this.isp_fractional))) + "'>" + ($e($c($.toFixed(this.isp_decimal, 2)))) + "</div>\n      <div class='" + (['isp-fractional', "" + ($e($c(this.options.show_fractional_odds ? "" : "hidden")))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-title='" + ($e($c(this.isp_decimal))) + "'>" + ($e($c(this.isp_fractional))) + "</div>");
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.place_price) {
        $o.push("  <td class='hover place_price'>\n    <div class='updates'>");
        if (this.place_price.value) {
          value = $.toFixed(this.place_price.value, 2);
          $o.push("      " + $e($c(this.place_price.sp ? value : "(" + value + ")")));
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.form) {
        $o.push("  <td class='form hover'>\n    <div>" + ($e($c(this.form))) + "</div>\n  </td>");
      }
      $o.push("  " + $c(window.HAML["races/client/templates/_r_values"](this.run)));
      if (this.columns.enabled.av10) {
        $o.push("  <td class='av10 hover'>\n    <div class='average updates' style='" + ($e($c(this.av10.colour ? "background: #" + this.av10.colour + ";" : ""))) + "'>");
        if (this.av10.value) {
          $o.push("      " + $e($c($.toFixed(this.av10.value, 2))));
        } else {
          $o.push("      \-");
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.av10_rank) {
        $o.push("  <td class='av10_rank hover'>\n    <div class='updates' style='" + ($e($c(this.av10_rank.colour ? "background: #" + this.av10_rank.colour + ";" : ""))) + "'>");
        $o.push("      " + $e($c(this.av10_rank.value)));
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.av3) {
        $o.push("  <td class='av3 hover'>\n    <div class='average updates' style='" + ($e($c(this.av3.colour ? "background: #" + this.av3.colour + ";" : ""))) + "'>");
        if (this.av3.value) {
          $o.push("      " + $e($c($.toFixed(this.av3.value, 2))));
        } else {
          $o.push("      \-");
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.av3_rank) {
        $o.push("  <td class='av3_rank hover'>\n    <div class='updates' style='" + ($e($c(this.av3_rank.colour ? "background: #" + this.av3_rank.colour + ";" : ""))) + "'>");
        $o.push("      " + $e($c(this.av3_rank.value)));
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled["class"]) {
        $o.push("  <td class='class hover'>\n    <div>");
        if (this.class_change > 0) {
          $o.push("      \+" + this.class_change);
        } else {
          $o.push("      " + $e($c(this.class_change)));
        }
        $o.push("    </div>\n  </td>");
      }
      if (this.columns.enabled.sex) {
        $o.push("  <td class='hover sex'>\n    <div data-title='" + ($e($c(this.sex.title))) + "'>" + ($e($c(this.sex.value))) + "</div>\n  </td>");
      }
      if (this.columns.enabled.age) {
        $o.push("  <td class='age hover'>\n    <div>" + ($e($c(this.age))) + "</div>\n  </td>");
      }
      if (this.columns.enabled.days) {
        $o.push("  <td class='days hover'>\n    <div>" + ($e($c(this.days))) + "</div>\n  </td>");
      }
      $.extend(this.run, {
        options: this.options,
        columns: this.columns
      });
      $o.push("  " + $c(window.HAML["races/client/templates/_horse_stats"](this.run)));
      $o.push("  " + $c(window.HAML["races/client/templates/_trainer_stats"](this.run)));
      $o.push("  " + $c(window.HAML["races/client/templates/_jockey_stats"](this.run)));
      $o.push("  " + $c(window.HAML["races/client/templates/_sire_stats"](this.run)));
      $o.push("  " + $c(window.HAML["races/client/templates/_combination_stats"](this.run)));
      if (this.columns.enabled.combined_ae) {
        if (this.run.combined_ae.value != null) {
          $o.push("  <td class='combined_ae hover' style='background: #" + ($e($c(this.run.combined_ae.colour))) + ";'>\n    <div>" + ($e($c($.toFixed(this.run.combined_ae.value, 2)))) + "</div>\n  </td>");
        } else {
          $o.push("  <td class='combined_ae hover'>\n    <div></div>\n  </td>");
        }
      }
      if (!this.options.extended_info) {
        $o.push("  <td class='hover locked_extra_stats' data-title='Only Premium Members get to see these'>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;' aria-hidden='true'></i>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;' aria-hidden='true'></i>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;' aria-hidden='true'></i>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;' aria-hidden='true'></i>\n    <i class='fa fa-lock' style='margin: 3px; font-size: 150%;' aria-hidden='true'></i>\n  </td>");
      }
      $o.push("</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_sire_stats'] = function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.columns.enabled.sire_name) {
        $o.push("" + $c(window.HAML["races/client/templates/_name"]($.extend(this.sire, {
          value: null,
          options: this.options
        }))));
      }
      if (this.columns.enabled.sire_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.a, {
          value: null,
          options: this.options,
          name: 'Sire stats'
        }))));
      }
      if (this.columns.enabled.sire_c_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.c, {
          value: null,
          options: this.options,
          name: 'Sire on this course stats'
        }))));
      }
      if (this.columns.enabled.sire_t_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.t, {
          value: null,
          options: this.options,
          name: 'Sire on this race type stats'
        }))));
      }
      if (this.columns.enabled.sire_d_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.d, {
          value: null,
          options: this.options,
          name: 'Sire on this distance stats'
        }))));
      }
      if (this.columns.enabled.sire_dt_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.dt, {
          value: null,
          options: this.options,
          name: 'Sire on this distance & race type stats'
        }))));
      }
      if (this.columns.enabled.sire_cd_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.cd, {
          value: null,
          options: this.options,
          name: 'Sire on this course & distance stats'
        }))));
      }
      if (this.columns.enabled.sire_g_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.sire.stats.g, {
          value: null,
          options: this.options,
          name: 'Sire on this going stats'
        }))));
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_stats_tip'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr>\n  <td style='height: 10px; width: 100px'></td>\n</tr>\n<tr>\n  <td>" + ($e($c(this.name_plural))) + "</td>\n  <td>" + this.sr.successes + " / " + this.sr.runs + " (" + this.value + ")</td>\n</tr>\n<tr>\n  <td>" + this.name + " A/E</td>\n  <td style='" + ($e($c('font-weight: bold; color: ' + $.colourAE(this.sr.ae)))) + "'>");
      $o.push("    " + $e($c(this.sr.ae != null ? $.toFixed(this.sr.ae, 2) : "")));
      $o.push("  </td>\n</tr>\n<tr>\n  <td>" + this.name + " P&L</td>\n  <td style='" + ($e($c('font-weight: bold; color: ' + $.colourProfitAndLoss(this.sr.p_and_l)))) + "'>");
      $o.push("    " + $c($.toGBP(this.sr.p_and_l)));
      $o.push("  </td>\n</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_stats'] = function(context) {
    return (function() {
      var $c, $e, $o, colour, combined_stats, combined_value, place_stats, place_value, primary_stats, secondary_stats, value, win_stats, win_value;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if ((this.options.stats_mode === "win_sr" || this.options.stats_mode === "place_sr") && this.win_sr) {
        $o.push("<td class='popup_mark stat'>");
        win_value = $.toPercentage(this.win_sr.successes / this.win_sr.runs, 2);
        win_stats = window.HAML["races/client/templates/_stats_tip"]({
          name: "Win",
          name_plural: "Wins",
          sr: this.win_sr,
          value: win_value
        });
        place_value = $.toPercentage(this.place_sr.successes / this.place_sr.runs, 2);
        place_stats = window.HAML["races/client/templates/_stats_tip"]({
          name: "Place",
          name_plural: "Places",
          sr: this.place_sr,
          value: place_value
        });
        combined_value = $.toPercentage(this.combined_sr.successes / this.combined_sr.runs, 2);
        combined_stats = window.HAML["races/client/templates/_stats_tip"]({
          name: "Combined",
          name_plural: "Combined",
          sr: this.combined_sr,
          value: combined_value
        });
        if (this.options.stats_mode === "win_sr") {
          value = win_value;
          colour = this.win_sr.colour;
          primary_stats = win_stats;
          secondary_stats = place_stats;
        } else {
          value = place_value;
          colour = this.place_sr.colour;
          primary_stats = place_stats;
          secondary_stats = win_stats;
        }
        $o.push("  <div data-title='<table><tr><th colspan=\"2\" style=\"border-bottom: 1px solid white;\"><strong>" + ($e($c(this.name))) + "</strong></th></tr> " + ($e($c(primary_stats))) + " " + ($e($c(secondary_stats))) + " " + ($e($c(combined_stats))) + "</table>' style='background: #" + ($e($c(colour))) + ";'>");
        $o.push("    " + $e($c(this.value || value)));
        $o.push("  </div>\n</td>");
      } else if (this.options.stats_mode === "win_pr" && this.win_pr) {
        $o.push("<td class='popup_mark stat'>");
        win_value = $.toPercentage(this.win_sr.successes / this.win_sr.runs, 2);
        value = $.toFixed(this.win_pr.value, 2);
        colour = this.win_pr.colour;
        $o.push("  <div data-title='<table><tr><td colspan=\"2\" style=\"border-bottom: 1px solid white;\"><strong>Win Price Reductions</strong></td></tr> <tr><td style=\"padding: 10px 40px 0 0;\">Average Price Reduction</td><td style=\"padding-top: 10px;\">" + ($e($c(value))) + "%</td></tr><tr><td>Price Reduced >= 25%</td><td>" + ($e($c($.toFixed(this.win_pr['25_percent'], 2)))) + "%</td></tr><tr><td>Price Reduced >= 50%</td><td>" + ($e($c($.toFixed(this.win_pr['50_percent'], 2)))) + "%</td></tr><tr><td>Price Reduced >= 75%</td><td>" + ($e($c($.toFixed(this.win_pr['75_percent'], 2)))) + "%</td></tr><tr><td>Wins</td><td>" + ($e($c(this.win_sr.successes))) + "&nbsp;/&nbsp;" + ($e($c(this.win_sr.runs))) + "&nbsp;(" + ($e($c(win_value))) + ")</td></tr></table>' style='background: #" + ($e($c(colour))) + ";'>\n    " + value + "%\n  </div>\n</td>");
      } else {
        $o.push("<td class='hover'></td>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/_trainer_stats'] = function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.columns.enabled.trainer_name) {
        $o.push("" + $c(window.HAML["races/client/templates/_name"]($.extend(this.trainer, {
          value: null,
          options: this.options
        }))));
      }
      if (this.columns.enabled.trainer_d7_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.d7, {
          value: null,
          options: this.options,
          name: 'Trainer in the last 7 days stats'
        }))));
      }
      if (this.columns.enabled.trainer_d14_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.d14, {
          value: null,
          options: this.options,
          name: 'Trainer in the last 14 days'
        }))));
      }
      if (this.columns.enabled.trainer_d28_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.d28, {
          value: null,
          options: this.options,
          name: 'Trainer in the last 28 days stats'
        }))));
      }
      if (this.columns.enabled.trainer_a_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.a, {
          value: null,
          options: this.options,
          name: 'Trainer stats'
        }))));
      }
      if (this.columns.enabled.trainer_c_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.c, {
          value: null,
          options: this.options,
          name: 'Trainer on this course stats'
        }))));
      }
      if (this.columns.enabled.trainer_t_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.t, {
          value: null,
          options: this.options,
          name: 'Trainer on this race type stats'
        }))));
      }
      if (this.columns.enabled.trainer_d_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.d, {
          value: null,
          options: this.options,
          name: 'Trainer on this distance stats'
        }))));
      }
      if (this.columns.enabled.trainer_dt_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.dt, {
          value: null,
          options: this.options,
          name: 'Trainer on this distance & race type stats'
        }))));
      }
      if (this.columns.enabled.trainer_cd_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.cd, {
          value: null,
          options: this.options,
          name: 'Trainer on this course & distance stats'
        }))));
      }
      if (this.columns.enabled.trainer_g_stats) {
        $o.push("" + $c(window.HAML["races/client/templates/_stats"]($.extend(this.trainer.stats.g, {
          value: null,
          options: this.options,
          name: 'Trainer on this going stats'
        }))));
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/nap_count_tip'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div>\n  <table>\n    <tr>\n      <td colspan='" + ($e($c(2))) + "' style='border-bottom: 1px solid white;'>\n        <div class='bold'>NAP Competition</div>\n      </td>\n    </tr>\n    <tr>\n      <td style='padding: 10px 20px 0 0;'>\n        Number of times picked today\n      </td>\n      <td style='padding-top: 10px;'>\n        <span style='" + ($e($c(this.rtr_rank_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.num_picks + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td colspan='" + ($e($c(2))) + "' style='border-bottom: 1px solid white; padding-top: 20px;'>\n        <div class='bold'>Player NAP Statistics</div>\n      </td>\n    </tr>\n    <tr>\n      <td style='padding: 10px 20px 0 0;'>\n        Average picks\n      </td>\n      <td style='padding-top: 10px;'>\n        <span style='" + ($e($c(this.rtr_rank_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + ($.toFixed(this.average_picks, 2)) + "\n        </span>\n      </td>\n    </tr>");
      if (this.average) {
        $o.push("    <tr>\n      <td>\n        Average strike rate\n      </td>\n      <td>\n        " + ($.toFixed(this.average.sr, 2)) + "%\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Average all-time P&L\n      </td>\n      <td>\n        <span style='font-weight: bold; color: " + ($e($c($.colourProfitAndLoss(this.average.p_and_l)))) + ";'>");
        $o.push("          " + $c($.toGBP(this.average.p_and_l)));
        $o.push("        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Average all-time ROI\n      </td>\n      <td style='font-weight: bold; color: " + ($e($c($.colourROI(this.average.roi)))) + ";'>\n        " + ($.toFixed(this.average.roi, 2)) + "%\n      </td>\n    </tr>");
      }
      $o.push("  </table>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/r_data_tip'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div>\n  <table>\n    <tr>\n      <td colspan='" + ($e($c(2))) + "' style='border-bottom: 1px solid white;'>\n        <div class='bold center'>Run Details</div>\n      </td>\n    </tr>\n    <tr>\n      <td style='padding: 10px 20px 0 0;'>\n        RTR Rank\n      </td>\n      <td style='padding-top: 10px;'>\n        <span style='" + ($e($c(this.rtr_rank_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.rtr_rank + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Course\n      </td>\n      <td>\n        <span style='" + ($e($c(this.course_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.course + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Distance\n      </td>\n      <td>\n        <span style='" + ($e($c(this.distance_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.distance + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Going\n      </td>\n      <td>\n        <span style='" + ($e($c(this.going_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.going + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Race type\n      </td>\n      <td>\n        <span style='" + ($e($c(this.race_type_em ? "font-weight: bold; color: yellow;" : ""))) + "'>\n          " + this.race_type + "\n        </span>\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Date\n      </td>\n      <td>\n        " + this.date + "\n      </td>\n    </tr>\n    <tr>\n      <td>\n        Form\n      </td>\n      <td>\n        " + this.form + "\n      </td>\n    </tr>\n  </table>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/table'] = function(context) {
    return (function() {
      var $c, $e, $o, column, i, j, k, l, len, len1, len2, len3, ref, ref1, ref2, ref3, ret, run, value;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<table class='race-table table table-bordered table-condensed' id='race-" + this.id + "' data-race-id='" + ($e($c(this.id))) + "'>\n  <colgroup>");
      ref = this.columns.names;
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        $o.push("    <col class='" + ($e($c(column))) + "'>");
      }
      $o.push("  </colgroup>\n  <thead>\n    <tr class='" + (['card-header', "" + ($e($c(this.is_abandoned ? "abandoned" : this.options.stats_mode)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-time='" + ($e($c(this.time))) + "' data-course='" + ($e($c(this.course.name))) + "'>\n      <th colspan='" + ($e($c(this.columns.names.length))) + "'>\n        <div class='details'>\n          <div class='name'>\n            <div class='h3'>\n              <a class='inv unlink-on-mobile' id='race-" + this.id + "' href='" + ($e($c(this.url))) + "' data-title='View individual race'>");
      $o.push("                " + $e($c(this.time)));
      $o.push("                <span class='usertz'>");
      $o.push("                  " + $e($c($.toUserTimeZone(this.time))));
      $o.push("                </span>\n              </a>");
      $o.push("              " + $e($c(" ")));
      $o.push("              <a class='inv unlink-on-mobile' href='" + ($e($c(this.racecard_url))) + "' data-title='View racecard'>" + ($e($c(this.course.name))) + "</a>");
      if (this.course.track.desc) {
        $o.push("              <span data-title='" + ($e($c(this.course.track.desc))) + "'>(" + this.course.track.abbr + ")</span>");
      }
      $o.push("            </div>\n            <span class='flag-icon flag-icon-" + this.course.flag + "' data-title='" + ($e($c(this.course.country))) + "'></span>");
      if (this.is_abandoned) {
        $o.push("            <span class='abandoned'>Abandoned</span>");
      }
      $o.push("          </div>\n          <div class='date'>" + ($e($c(this.name))) + "</div>\n        </div>");
      if (this.options.show_header) {
        $o.push("        <table class='table table-condensed'>\n          <thead>\n            <tr>\n              <th>Distance</th>\n              <th>Race Type</th>\n              <th>Class</th>\n              <th>Prize Money</th>\n              <th>Handicap?</th>\n              <th>Ages</th>\n              <th>Runners</th>\n              <th>Non-runners</th>\n              <th>Going</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr>\n              <td data-title='Approximately " + ($e($c(this.distance.furlongs))) + " furlongs'>" + ($e($c(this.distance.value))) + "</td>\n              <td>" + ($e($c(this.race_type))) + "</td>\n              <td>" + ($e($c(this.race_class))) + "</td>\n              <td>" + ($e($c(this.prize_money))) + "</td>\n              <td>" + ($e($c(this.is_handicap ? "Yes" : "No"))) + "</td>\n              <td>" + ($e($c(this.age_range))) + "</td>\n              <td>" + ($e($c(this.number_of_runners))) + "</td>\n              <td>" + ($e($c(this.number_of_non_runners))) + "</td>\n              <td class='js_going'>" + ($e($c(this.going))) + "</td>\n            </tr>\n          </tbody>\n        </table>\n        <table class='table table-condensed'>\n          <thead>\n            <tr>\n              <th>Win Overround</th>\n              <th>Place Overround</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr>\n              <td>");
        if (this.over_round) {
          $o.push("                " + $e($c($.toFixed(this.over_round, 2))));
          $o.push("                <div></div>");
        } else {
          $o.push("                \-");
        }
        $o.push("              </td>\n              <td>");
        if (this.place_over_round) {
          $o.push("                " + $e($c($.toFixed(this.place_over_round, 2))));
          $o.push("                <div></div>");
        } else {
          $o.push("                \-");
        }
        $o.push("              </td>\n            </tr>\n          </tbody>\n        </table>\n        <table class='table table-condensed'>\n          <thead>\n            <tr>");
        ref1 = this.returns;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          ret = ref1[j];
          $o.push("              <th>" + ($e($c(ret.label))) + "</th>");
        }
        $o.push("            </tr>\n          </thead>\n          <tbody>\n            <tr>");
        ref2 = this.returns;
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          ret = ref2[k];
          $o.push("              <td>");
          if (ret.value.length > 0) {
            $o.push("                " + $c(((function() {
              var l, len3, ref3, results;
              ref3 = ret.value;
              results = [];
              for (l = 0, len3 = ref3.length; l < len3; l++) {
                value = ref3[l];
                results.push($.toGBP(value));
              }
              return results;
            })()).join(", ")));
          } else {
            $o.push("                \-");
          }
          $o.push("              </td>");
        }
        $o.push("            </tr>\n          </tbody>\n        </table>");
      }
      $o.push("      </th>");
      if (this.options.show_headings && this.columns.enabled) {
        $o.push("      " + $c(window.HAML["races/client/templates/_headings"]($.extend(this.columns.enabled, {
          options: this.options
        }))));
      }
      $o.push("    </tr>\n    <tbody>");
      ref3 = this.runs;
      for (l = 0, len3 = ref3.length; l < len3; l++) {
        run = ref3[l];
        run.run = run;
        $o.push("      " + $c(window.HAML["races/client/templates/_run"]($.extend(run, {
          race: this.race,
          options: this.options,
          columns: this.columns,
          entry: this.entry
        }))));
      }
      $o.push("    </tbody>\n  </thead>\n</table>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['races/client/templates/update_table'] = function(context) {
    return (function() {
      var $c, $e, $o, column, i, j, len, len1, ref, ref1;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<table class='race-update'>\n  <colgroup>");
      ref = this.columns.names;
      for (i = 0, len = ref.length; i < len; i++) {
        column = ref[i];
        $o.push("    <col class='" + ($e($c(column))) + "'>");
      }
      $o.push("  </colgroup>\n  <tbody>\n    <tr>");
      ref1 = this.columns.names;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        column = ref1[j];
        if (this.columns.enabled[column]) {
          $o.push("      <td class='" + ($e($c(column))) + "'>\n        <i class='black glyphicon glyphicon-time' style='display: none;' data-title='" + ($e($c(this.update_text[column]))) + "'></i>\n      </td>");
        }
      }
      $o.push("    </tr>\n  </tbody>\n</table>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['rating_the_races/client/templates/pagination'] = function(context) {
    return (function() {
      var $c, $e, $o, i, j, max, min, ref, ref1;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<button class='" + (['btn', 'btn-default', "" + ($e($c(this.page === 1 ? 'active' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-page='" + ($e($c(this.page - 1))) + "' data-title='Previous page'>\n  <i class='glyphicon glyphicon-play icon-flipped'></i>\n</button>\n<button class='" + (['btn', 'btn-default', "" + ($e($c(this.page === 1 ? 'active' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-page='" + ($e($c(1))) + "' data-title='Go to page 1 (first page)'>" + ($e($c(1))) + "</button>");
      min = Math.max(2, this.page - 1);
      if (min === 3) {
        min -= 1;
      }
      max = Math.min(this.num_pages - 1, this.page + 1);
      if (max === this.num_pages - 2) {
        max += 1;
      }
      if (max >= min) {
        if (min > 3) {
          $o.push("<button class='btn btn-default disabled'>&hellip;</button>");
        }
        for (i = j = ref = min, ref1 = max; ref <= ref1 ? j <= ref1 : j >= ref1; i = ref <= ref1 ? ++j : --j) {
          $o.push("<button class='" + (['btn', 'btn-default', "" + ($e($c(this.page === i ? 'active' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-page='" + ($e($c(i))) + "' data-title='Go to page " + ($e($c(i))) + "'>" + ($e($c(i))) + "</button>");
        }
        if (max < this.num_pages - 2) {
          $o.push("<button class='btn btn-default disabled'>&hellip;</button>");
        }
      }
      $o.push("<button class='" + (['btn', 'btn-default', "" + ($e($c(this.page === this.num_pages ? 'active' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-page='" + ($e($c(this.num_pages))) + "' data-title='Go to page " + ($e($c(this.num_pages))) + " (last page)'>" + ($e($c(this.num_pages))) + "</button>\n<button class='" + (['btn', 'btn-default', "" + ($e($c(this.page === this.num_pages ? 'active' : '')))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-page='" + ($e($c(this.page + 1))) + "' data-title='Next page'>\n  <i class='glyphicon glyphicon-play'></i>\n</button>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['stats/client/templates/add_user_filters_dialog'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='modal-header'>\n  <button class='close' type='button' data-dismiss='modal' aria-label='Close' data-placement='bottom' data-title='Close the dialog'>\n    <span aria-hidden='true'>&times;</span>\n  </button>\n  <div class='h1 modal-title'>\n    <span>Add filter set</span>\n  </div>\n</div>\n<div class='modal-body'>\n  <p>Create a filter set, based on the current filters.</p>\n  <div class='input-group'>\n    <div class='input-group-addon'>Name</div>\n    <input class='form-control' id='stats-filter-name' name='name' value='' maxlength='" + ($e($c(this.max_name_length))) + "'>\n  </div>\n</div>\n<div class='modal-footer'>\n  <button class='btn btn-primary' type='button' disabled data-title='Add to your saved filter sets' data-action='add'>Add</button>\n  <button class='btn btn-default' type='button' data-dismiss='modal'>Cancel</button>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['stats/client/templates/filter_badge'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<li>\n  <div class='badge badge-info filter' data-name='" + ($e($c(this.name))) + "'>\n    <button class='btn btn-default btn-remove-filter-group hidden' data-action='remove' data-title='Remove filters'>\n      <i class='glyphicon glyphicon-remove text-danger' aria-hidden='true'></i>\n    </button>\n    <span class='filter'>" + this.label + ":</span>\n    <span class='values'></span>\n  </div>\n</li>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['stats/client/templates/filter_value'] = function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<span class='value' data-value='" + ($e($c(this.value))) + "'>");
      if (!this.is_initial) {
        $o.push("  <span class='or'>OR</span>");
      }
      $o.push("  <span class='name'>" + this.label + "</span>\n  <button class='btn btn-default' data-action='remove' data-title='Remove filter'>\n    <i class='glyphicon glyphicon-remove' aria-hidden='true'></i>\n  </button>\n</span>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);

(function() {
  if (window.HAML == null) {
    window.HAML = {};
  }

  window.HAML['stats/client/templates/stats_row'] = function(context) {
    return (function() {
      var $c, $e, $o, class_, i, len, ref, row;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      ref = this.rows;
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        class_ = row.title === "All" ? "total" : "";
        $o.push("<tr class='" + class_ + "'>\n  <td data-key='" + ($e($c(row.key))) + "'>" + ($e($c(row.title))) + "</td>\n  <td class='right'>");
        $o.push("    " + $e($c(row.runners || 0)));
        $o.push("  </td>\n  <td class='right'>");
        $o.push("    " + $e($c(row.non_runners || 0)));
        $o.push("  </td>\n  <td class='right'>" + ($e($c(row.won || 0))) + "</td>\n  <td class='right'>");
        if (row.sr != null) {
          $o.push("    " + ($.toFixed(row.sr, 2)) + "%");
        }
        $o.push("  </td>\n  <td class='right'>");
        if (row.average_price_bfsp) {
          $o.push("    " + $e($c($.toFixed(row.average_price_bfsp, 2))));
        }
        $o.push("  </td>\n  <td class='" + (['right', 'chart', "" + ($e($c($.profitAndLossClass(row.p_and_l_bfsp))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-extra-data-key='" + ($e($c(row.extra_data_key))) + "'>");
        if (row.p_and_l_bfsp != null) {
          $o.push("    " + $e($c($.toFixed(row.p_and_l_bfsp, 2))));
          $o.push("    <i class='glyphicon glyphicon-stats'></i>");
        }
        $o.push("  </td>\n  <td class='" + (['right', "" + ($e($c($.profitAndLossClass(row.roi_bfsp))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
        if (row.roi_bfsp != null) {
          $o.push("    " + ($.toFixed(row.roi_bfsp, 2)) + "%");
        }
        $o.push("  </td>\n  <td class='js_isp right'>");
        if (row.average_price_isp) {
          $o.push("    " + $e($c($.toFixed(row.average_price_isp, 2))));
        }
        $o.push("  </td>\n  <td class='" + (['right', 'js_isp', "" + ($e($c($.profitAndLossClass(row.p_and_l_isp))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
        if (row.p_and_l_isp != null) {
          $o.push("    " + $e($c($.toFixed(row.p_and_l_isp, 2))));
        }
        $o.push("  </td>\n  <td class='" + (['right', 'js_isp', "" + ($e($c($.profitAndLossClass(row.roi_isp))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
        if (row.roi_isp != null) {
          $o.push("    " + ($.toFixed(row.roi_isp, 2)) + "%");
        }
        $o.push("  </td>\n</tr>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
